import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './Tabs.css';
import React, { useState } from 'react';
import { canUseDOM, get, getColorByTheme, getPageThemeColors } from '../../utils';
import { RichText, Text, Link, Image } from '@sitecore-jss/sitecore-jss-react';
import RouterLink from '../atoms/RouterLink';
import LazyPicture from '../atoms/LazyPicture';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
var Tabs = function Tabs(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var clickCategoryAnalytics = fields.data.clickCategoryAnalytics;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  var _useState3 = useState(function () {
      return canUseDOM ? window.matchMedia("(max-width: 767px)").matches : false;
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    isMobile = _useState4[0],
    setIsMobile = _useState4[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
    if (canUseDOM) {
      window.addEventListener("resize", function () {
        setIsMobile(window.matchMedia("(max-width: 767px)").matches);
      });
    }
    return function () {
      if (canUseDOM) {
        window.addEventListener("resize", function () {
          setIsMobile(window.matchMedia("(max-width: 767px)").matches);
        });
      }
    };
  }, []);
  var templateName = get(sitecoreContext, "route.templateName");
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var variables = BackgroundColorHex ? {
    '--m49-tabs-primary-color': BackgroundColorHex,
    '--m49-tabs-active-color': ActiveColorHex,
    '--m49-tabs-color': ColorHex
  } : {
    '--m49-tabs-primary-color': selectedPrimaryColor,
    '--m49-tabs-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--m49-tabs-color': getColorByTheme(selectedPrimaryColor)
  };
  var switchTab = React.useCallback(function (e) {
    var index = e.currentTarget.getAttribute('data-tab');
    setActiveTab(parseInt(index, 10));
  }, []);
  if (!fields || !fields.data || !fields.data.item) {
    console.info('Tabs component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", null, "[Tabs component is empty: please provide data source]");
    }
    return null;
  }
  var title = get(fields, 'data.item.title.jss');
  var titleValue = String(title ? title.value || '' : '');
  var subTitle = get(fields, 'data.item.subtitle.jss', '');
  var subTitleValue = String(title ? title.value || '' : '');
  var hasItems = Boolean(get(fields, 'data.item.children.length'));
  var items = hasItems ? fields.data.item.children : [];
  var tabAnalytics = fields.data.tabAnalytics;
  var renderTabs = /*#__PURE__*/React.createElement("div", {
    className: "tabs",
    "data-cy": "tabs",
    style: variables
  }, Boolean(titleValue.trim() || subTitleValue.trim()) && /*#__PURE__*/React.createElement("h3", {
    className: "h3 tabs__title",
    "data-cy": "tabs-title"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "",
    field: title
  }), " ", /*#__PURE__*/React.createElement("br", null), Boolean(subTitleValue) && /*#__PURE__*/React.createElement("span", {
    className: "title--light",
    "data-cy": "tabs-subtitle"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "",
    field: subTitle
  }))), /*#__PURE__*/React.createElement("div", {
    className: "tabs-group",
    "data-cy": "tabs-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tabs-heading col-xs-12 rs_skip"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "h__list scroll-no-style"
  }, items.map(function (item, index) {
    var itemTitlteField = get(item, 'title.jss', '');
    if (!itemTitlteField.value) {
      return null;
    }
    if (!pageEditing) {
      return /*#__PURE__*/React.createElement("li", {
        key: itemTitlteField.value,
        className: "h__item ".concat(activeTab === index ? 'active' : ''),
        "data-tab": index,
        onClick: switchTab
      }, /*#__PURE__*/React.createElement("a", {
        href: "#",
        onClick: function onClick(e) {
          e.preventDefault();
          tealiumClickFunc(tealiumMergeClickData(tabAnalytics, {
            eventAct: params.eventAct,
            eventCat: params.eventCat
          }), item.name);
        }
      }, itemTitlteField.value));
    } else {
      return /*#__PURE__*/React.createElement("li", {
        key: itemTitlteField.value,
        className: "h__item"
      }, /*#__PURE__*/React.createElement(Text, {
        tag: "div",
        field: itemTitlteField
      }));
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "tabs-body col-xs-12",
    "data-cy": "tabs-body"
  }, items.map(function (item, index) {
    var hasCtaLabel = Boolean(get(item, 'ctaLabel.jss.value'));
    var ctaLabel = get(item, 'ctaLabel.jss.value');
    var ctaAnalytics = get(item, 'ctaAnalytics.jss.value', ctaLabel);
    var ctaLinkHref = get(item, 'ctaLink.jss.value.href', '');
    var desc = get(item, 'description.jss');
    var itemTitlte = get(item, 'title.jss.value', '');
    if (!itemTitlte) {
      return null;
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", {
      className: pageEditing ? '' : 'd-none'
    }, itemTitlte), /*#__PURE__*/React.createElement("div", {
      className: "tabs-content ".concat(activeTab === index ? 'active' : '', " ").concat(pageEditing ? 'active' : '', " ").concat(item.image && item.image.jss.value.src ? 'tabs-content--has-image' : null),
      style: pageEditing ? {
        marginBottom: '40px'
      } : {},
      key: itemTitlte
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-bloc__txt"
    }, /*#__PURE__*/React.createElement(RichText, {
      className: "c__txt",
      tag: "div",
      field: desc
    }), isMobile && item.image && item.image.jss.value.src && /*#__PURE__*/React.createElement(React.Fragment, null, !pageEditing ? /*#__PURE__*/React.createElement(LazyPicture, {
      className: "c__img"
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 440px)",
      srcSet: "".concat(item.image.jss.value.src)
    }), /*#__PURE__*/React.createElement("img", {
      "data-cy": "tabs-body-image",
      src: "".concat(item.image.jss.value.src, "&cw=430&ch=430"),
      alt: item.image.jss.value.alt
    })) : /*#__PURE__*/React.createElement(Image, {
      editable: true,
      field: item.image.jss
    })), hasCtaLabel && ctaLinkHref && (pageEditing ? /*#__PURE__*/React.createElement(Link, {
      className: "btn btn-primary tab-btn",
      field: item.ctaLink.jss
    }) : /*#__PURE__*/React.createElement(RouterLink, {
      className: "btn btn-primary tab-btn",
      href: ctaLinkHref,
      dataCy: "tabs-body-cta",
      linktype: item.ctaLink.jss.value.linktype,
      title: "".concat(itemTitlte, " | ").concat(item.ctaLabel.jss.value),
      onClick: function onClick() {
        tealiumClickFunc(tealiumMergeClickData(clickCategoryAnalytics, {
          eventAct: params.eventAct,
          eventCat: params.eventCat
        }), [item.name, ctaAnalytics]);
      }
    }, item.ctaLabel.jss.value))), !isMobile && item.image && item.image.jss.value.src && /*#__PURE__*/React.createElement(React.Fragment, null, !pageEditing ? /*#__PURE__*/React.createElement(LazyPicture, {
      className: "c__img",
      style: {
        flexShrink: 0
      }
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 991px)",
      srcSet: "".concat(item.image.jss.value.src, "&cw=460&ch=345")
    }), /*#__PURE__*/React.createElement("img", {
      "data-cy": "tabs-body-image",
      src: "".concat(item.image.jss.value.src, "&cw=300&ch=345"),
      alt: item.image.jss.value.alt
    })) : /*#__PURE__*/React.createElement(Image, {
      editable: true,
      field: item.image.jss
    }))));
  }))));
  if (templateName === "Weather Information Page") {
    return /*#__PURE__*/React.createElement(StyledWrapper, {
      rtl: rtl,
      anchorUrlParameter: params['Anchor Url Parameter']
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-md-1"
    }), /*#__PURE__*/React.createElement("div", {
      className: "col-md-10"
    }, renderTabs), /*#__PURE__*/React.createElement("div", {
      className: "col-md-1"
    })));
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, renderTabs);
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "ccw3y7n";
var ltrStyles = "lw99v5t";
var rtlStyles = "r1da4qmh";
export default Tabs;